import type { DefineNumberFormat } from 'vue-i18n';

const formats: DefineNumberFormat = {
  decimal: {
    style: 'decimal',
    minimumFractionDigits: 0,
    maximumFractionDigits: 2
  },
  currency: {
    style: 'decimal',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }
} as const;

export default formats;
